import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  TextInputButton,
  type TextInputButtonSize,
} from "@stenajs-webui/elements";
import type { FC, Ref } from "react";

import {
  getInformationMessageInfo,
  type InformationMessageType,
} from "./informationMessageUtils";

export interface InformationMessageIconProps {
  icon?: IconDefinition;
  onClick?: () => void;
  ref?: Ref<HTMLButtonElement>;
  size?: TextInputButtonSize;
  tabIndex?: number;
  type: InformationMessageType;
}

export const InformationMessageIcon: FC<InformationMessageIconProps> = ({
  type,
  ...props
}) => {
  const info = getInformationMessageInfo(type);

  return <TextInputButton {...props} variant={info.variant} />;
};
